import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    let lastScrollTop = 0;
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Toujours afficher le header en haut de la page
      if (scrollTop <= 10) {
        setIsScrolled(false);
        lastScrollTop = scrollTop;
        return;
      }
      
      // Masquer le header quand on scroll vers le bas
      // Afficher le header quand on scroll vers le haut
      if (scrollTop > lastScrollTop && scrollTop > 100) {
        // Scroll vers le bas : masquer le header
        setIsScrolled(true);
      } else if (scrollTop < lastScrollTop) {
        // Scroll vers le haut : afficher le header
        setIsScrolled(false);
      }
      
      lastScrollTop = scrollTop;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fermer le menu quand on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target) && isMenuOpen) {
        setIsMenuOpen(false);
        document.body.style.overflow = '';
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleNavClick = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = '';
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <nav className="nav" ref={navRef}>
          <Link to="/" className="logo-link" onClick={handleNavClick}>
            <div className="logo">
              <img src="/cns.png" alt="Logo CNS" className="logo-img" height="48" />
              <span className="logo-text">CNS</span>
            </div>
          </Link>
          
          <button 
            className={`burger ${isMenuOpen ? 'active' : ''}`}
            aria-label="Ouvrir le menu"
            aria-expanded={isMenuOpen}
            aria-controls="main-nav"
            onClick={() => {
              setIsMenuOpen(!isMenuOpen);
              document.body.style.overflow = isMenuOpen ? '' : 'hidden';
            }}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          <ul id="main-nav" className={isMenuOpen ? 'open' : ''}>
            <li><Link to="/" onClick={handleNavClick} className={location.pathname === '/' ? 'active' : ''}>Accueil</Link></li>
            <li><Link to="/services" onClick={handleNavClick} className={location.pathname === '/services' ? 'active' : ''}>Services</Link></li>
            <li><Link to="/realisations" onClick={handleNavClick} className={location.pathname === '/realisations' ? 'active' : ''}>Réalisations</Link></li>
            <li><Link to="/contact" onClick={handleNavClick} className={location.pathname === '/contact' ? 'active' : ''}>Contactez-nous</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;

